// extracted by mini-css-extract-plugin
module.exports = {"container":"_320f_Gq4 align-middle","icon":"_1MM9g73H"};